import { COMPANY_URL } from "../../constants/apiUrls";
import { apiSlice } from "../apiSlice";

export const searchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchCompany: builder.query({
      query: ({ searchQuery, worldBoxToken, code }) => ({
        url: `api/company/worldbox-search/?q=${searchQuery}&countrycode=${code}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    searchTrevexCompany: builder.query({
      query: ({ token, searchTerm, code }) => ({
        url: `api/company/details/?search=${searchTerm}&country_code=${code}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompanyNew: builder.query({
      query: ({ id: win, worldBoxToken }) => ({
        url: `api/company/worldbox-search/${win}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useSearchCompanyQuery,
  useSearchTrevexCompanyQuery,
  useGetCompanyNewQuery,
} = searchApiSlice;
